import React, { Component } from "react";
import { IconButton } from "@material-ui/core";
import { Translation } from "react-i18next";
import Menu from "@material-ui/core/Menu";
import { connect } from "react-redux";
import { styles } from "./Styles.css";
import { withStyles } from "@material-ui/core";
import {
  setResultView,
  setAdvSearch,
  setQuery,
  selectItems,
  focusItem,
  search,
  updateSearchUserPref,
  clear,
  showMessage,
  RemoveTrack,
  cloudClose,
  cloudSearch,
  showAutoMessage,
  copyTrack
} from "../../../redux/actions/MlTrackLibraryActions";
import {
  showAutoMessage as playoutShowAutoMessage, 
  checkAndCreateOpenPlayout,
  checkOpenPlayout,
  addTracksToPlayout
} from "../../../redux/actions/MlPlayoutSessionAction"
import {
  craeteAndPublishPlayoutTracks,
  search as trackSearch
} from "../../../redux/actions/MlPlayoutTracksAction";
import { GetUpdateTrack, emptySession, contentTrackEditItem } from "../../../redux/actions/MLTrackUpdateAction";

import {
  setPlaylistTracks,
  loadEdittablePlaylist,
  setPlrecentQuery,
} from "../../../redux/actions/MlPlaylistActions";

import {
  setRecentCFQuery,
  searchCFRecent,
  postItem,
} from "../../../redux/actions/MlLicFormActions";

import { postItem as postItemTrack } from "../../../redux/actions/MlTrackLibraryActions";

import {
  editMessage,
  setEditMessageCB,
} from "../../messages/redux/MessagesActions";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import TableDataCol from "./../../../util/TableDataCol";
// import trackFields from "../../../_module/definition/trackFields";
import Columns from "./Columns";
import ContextActions from "./ContextActions";

class DiscreteTracks extends Component {
  constructor() {
    super();
    this.state = {
      anchorEl: null,
    };
  }

  handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    this.setState({ anchorEl: e.currentTarget });
  } 
  handleClose = () => this.setState({ anchorEl: null });
  columns = null;

  isRowFocused = (row) => {
    const {
      data: { selectedItem },
    } = this.props;
    return selectedItem && selectedItem.id && selectedItem.id === row.id;
  };

  render() {
    const { 
      classes, 
      track, 
      focusItem ,
      orgRuntime: {
        runtime: {
          _trackFields: trackFields,
      
        }
      } 
    } = this.props;
    
    const { anchorEl } = this.state;
    return (
      <Translation>
        {(t, { i18n }) => {
          if (!this.columns && Boolean(anchorEl)) {
            this.columns = [
              "player",
              trackFields.trackTitle.id,
              trackFields.trackVersionTitle.id,
              trackFields.performer.id,
              trackFields.isrc.id,
              trackFields.prodName.id,
              trackFields.catNo.id,
              "menu",
            ].map((v) => {
              let label =
                !trackFields[v] || trackFields[v]?.sys
                  ? ""
                  : i18n.t(`modules.${v}`);
              return {
                ...(Columns[v] || {}),
                field: v,
                type: Columns[v].type,
                label,
              };
            });
          }

          return track.discretedTracks && track.discretedTracks.length > 0 ? (
            <>
              <IconButton
                aria-controls="action"
                aria-haspopup="true"
                aria-label={`${track.discretedTracks.length} ${t("libraryTools.discretedTracks")}`}
                title={`${track.discretedTracks.length} ${t("libraryTools.discretedTracks")}`}
                onClick={this.handleClick}
              >
                <span>({track.discretedTracks.length})</span>
              </IconButton>
              <Menu
                keepMounted
                getContentAnchorEl={null}
                anchorOrigin={{
                  horizontal: "left",
                  vertical: "bottom",
                }}
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  this.handleClose();
                }}
              >
                {Boolean(anchorEl) ? (
                  <TableContainer
                    className={classes.discreteTableData}
                    component={Paper}
                  >
                    <Table
                      stickyHeader
                      className={classes.tableDataList}
                      aria-label={t("libraryTools.discreteTracks")}
                    >
                      <TableHead>
                        <TableRow>
                          {this.columns.map((column) => (
                            <TableCell width={column.width}>
                              {column.label}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {track.discretedTracks &&
                          track.discretedTracks.map((row) => {
                            const isFocused = this.isRowFocused(row);
                            return (
                              <TableRow
                                key={row.id}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                  focusItem(row);
                                }}
                                className={
                                  isFocused
                                    ? classes.tableFocusedRow
                                    : classes.tableUnfocusedRow
                                }
                              >
                                {this.columns.map((c, i) => (
                                  <TableDataCol
                                    key={c.field + row.id}
                                    {...this.props}
                                    column={c}
                                    row={row}
                                    rowId={row.id}
                                    selected={false}
                                    contextActions={
                                      <ContextActions {...this.props} />
                                    }
                                  />
                                ))}
                              </TableRow>
                            );
                          })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : null}
              </Menu>
            </>
          ) : null;
        }}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.mltracklibrary,
  playlist: state.mlplaylist,
  cf: state.mllicform,
  trackData: state.mlPlayoutTracksReducer,
  sessionData: state.mlPlayoutSessionReducer,
  orgRuntime: state.orgRuntime,
  bulkEditData: state.bulkEdit,
});

export default connect(mapStateToProps, {
  setResultView,
  setAdvSearch,
  setQuery,
  selectItems,
  focusItem,
  search,
  setPlaylistTracks,
  updateSearchUserPref,
  loadEdittablePlaylist,
  setPlrecentQuery,
  clear,
  showMessage,
  setRecentCFQuery,
  searchCFRecent,
  postItem,
  editMessage,
  setEditMessageCB,
  RemoveTrack,
  GetUpdateTrack,
  cloudClose,
  postItemTrack,
  cloudSearch,
  playoutShowAutoMessage,
  checkAndCreateOpenPlayout,
  addTracksToPlayout,
  craeteAndPublishPlayoutTracks,
  showAutoMessage,
  checkOpenPlayout,
  trackSearch,
  emptySession,
  copyTrack,
  contentTrackEditItem
})(withStyles(styles)(DiscreteTracks));
